export const MISSING_FIELD = {
  EMAIL: 'email',
  MOBILE: 'mobile',
};
